<template>
  <div class="planning">
    <mt-header title="展馆规划">
      <span slot="left" @click="()=>this.$router.back()">
        <i class="iconfont icon-left"></i>
        Return
      </span>
    </mt-header>
    <div class="detailsContent">
      <div>
        <div class="banner">
          <img src="http://public.cippe.com.cn/static/hall/2020bj/Floor_Plan_of_NCIEC.jpg" alt="" />
        </div>
        <div>
          <span class="scopeL"></span>
          <span class="scopeC">Exhibition Floor Plan</span>
          <span class="scopeR"></span>
        </div>
        <ul class="ulList">
          <li v-for="(item,i) in list" :key="'about'+i" @click="popupVisible=true;imgItem=item.url">
            <div>
              <img :src="item.url" alt="" />
            </div>
            <p>{{item.area}}</p>
            <p>{{item.intro}}</p>
          </li>
        </ul>
        <div class="btn">
          <button @click="()=>$jumpWeb('https://www.cippe.com.cn/reg/')">Exhibit Now</button>
        </div>
      </div>
    </div>
    <mt-popup
      v-model="popupVisible"
      >
      <img :src="imgItem" alt="" />
    </mt-popup>
  </div>
</template>

<script>
import { Header, Popup } from 'mint-ui';
import "mint-ui/lib/header/style.css"
import "mint-ui/lib/popup/style.css"
export default {
  components:{
    'mt-header':Header,
    'mt-popup':Popup,
  },
  data () {
    return {
      list:[
        {
          url:"http://public.cippe.com.cn/static/hall/2020bj/hall_e1.jpg",
          area:"E1",
          intro:"CNPC,Petroleum Exploration,Drilling,Offshore Oil Equipment"
        },
        {
          url:"http://public.cippe.com.cn/static/hall/2020bj/hall_w1.jpg",
          area:"W1",
          intro:" International Exhibition Area"
        },
        {
          url:"http://public.cippe.com.cn/static/hall/2020bj/hall_e2.jpg",
          area:"E2",
          intro:"CNPC,Petroleum Exploration,Drilling,Offshore Oil Equipment"
        },
        {
          url:"http://public.cippe.com.cn/static/hall/2020bj/hall_w2.jpg",
          area:"W2",
          intro:"International Exhibition Area,Petroleum Equipment, Marine Engineering Equipment"
        },
        {
          url:"http://public.cippe.com.cn/static/hall/2020bj/hall_e3.jpg",
          area:"E3",
          intro:"Explosion Proof,Meter,Electrical Equipment, Pipeline Fluid,Petroleum Equipment Accessories"
        },
        {
          url:"http://public.cippe.com.cn/static/hall/2020bj/hall_w3.jpg",
          area:"W3",
          intro:"International Exhibition Area, Petroleum Equipment, Marine Engineering Equipment"
        },
        {
          url:"http://public.cippe.com.cn/static/hall/2020bj/hall_e4.jpg",
          area:"E4",
          intro:"Natural Gas, Shale Gas, Explosion Proof, Safety Protection"
        },
        // {
        //   url:"http://public.cippe.com.cn/static/hall/2020bj/hall_e4.jpg",
        //   area:"W4",
        //   intro:"Natural Gas, Shale Gas, Explosion Proof, Safety Protection"
        // },
      ],
      popupVisible:false,
      imgItem:""
    }
  }

}
</script>

<style scoped>
  .planning{
    /* padding:0 20px; */
    background-color: white;
    height: 100%;
  }
  .mint-header{
    /* margin-left: -20px;
    margin-right: -20px; */
    height: 40px;
    background-color: #008baf;
    position: relative;
    z-index: 10;
  }
  .detailsContent{
    position: relative;
    z-index: 10;
    background-color: white;
  }
  .banner{
    margin-left: -10px;
    margin-right: -10px;
    max-height: 200px;
    height: 200px;
    margin-bottom: 20px;
    /* width: 100%; */
  }
  .banner img{
    object-fit:fill;
  }

  .showList{
    height: 150px;
    display: flex;
  }
  .showItem{
    width: 88.75px;
    height: 100%;
    box-sizing: border-box;
    padding: 10px;
    text-align: center;
    color: #008baf;
  }
  .showNum{
    width: 100%;
    line-height: 68.75px;
    border-radius: 50%;
    overflow: hidden;
    margin-bottom: 10px;
    color: white;
    font-size: 13px;
    font-weight: 600;
    background-color: #33a1be;
  }
  .scopeC{
    display: inline-block;
    width: 130px;
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    color: #008baf;
    line-height: 25px;
    vertical-align: middle;
  }
  .scopeL{
    display: inline-block;
    height: 1px;
    width: 112.5px;
    background-image: linear-gradient(to left , #008baf, #ffffff00);
    vertical-align: middle;
  }
  .scopeR{
    display: inline-block;
    height: 1px;
    width: 112.5px;
    background-image: linear-gradient(to right, #008baf, #ffffff00);
    vertical-align: middle;
  }
  .ulList{
    padding: 20px 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .ulList li{
    width: 170px;
    padding: 5px;
    box-sizing: border-box;
    box-shadow: 0 0 10px rgba(0, 0, 0, .3);
    color: #666666;
    line-height: 20px;
    font-size: 13px;
    margin-bottom: 15px;
    text-align: center;
  }
  .btn{
    text-align: center;
    padding-bottom: 20px;
  }
  .btn button{
    width: 180px;
    height: 40px;
    border: none;
    color: white;
    font-weight: bold;
    font-size: 17px;
    background-image: linear-gradient(to bottom ,#34b4d3 ,#027898);
    border-radius: 5px;
    outline: none;
  }
  .mint-popup{
    width: 98%;
  }
</style>